import { BrowserTracing, init, Replay, routingInstrumentation } from '@sentry/angular';

const SENTRY_DSN = 'https://73036dce6cc6ff1ccbb9410b432858d6@o4510312034992128.ingest.us.sentry.io/4510312092008448';
const ENV_URLS = [
    'app.vescent.co'
];

const browserTracing = new BrowserTracing({
  tracePropagationTargets: ENV_URLS,
  routingInstrumentation,
});

const replay = new Replay({
  maskAllText: true,
  blockAllMedia: true,
});

init({
  dsn: SENTRY_DSN,
  integrations: [browserTracing, replay],
  tracesSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 1.0
});
